import axios from 'axios';
import store from '@/store/Store';

// @ts-ignore
const API_URL = import.meta.env.VITE_API_URL;

export const submitFeedback = async (feedback) => {
  const token = store.getState().auth.token;

  if (!token) throw new Error('Not authenticated!');

  const res = await axios.post(API_URL + '/feedback', feedback, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};
